export default __webpack_public_path__ + "static/media/3e55056c8f68ee560570e4cb99fbf1b0.svg";